export default __webpack_public_path__ + "static/sparkle-virtual-cards-2564ec3db7a2862ef7660f4b94a4d458.svg";